import { Button, VisuallyHidden } from '@ds/components'

import type { TCookieBannerProps } from './CookieBanner.types'
import styles from './CookieBanner.module.css'

export const CookieBanner = ({
    labels,
    learnMoreHref,
    onAccept,
    onDecline,
}: TCookieBannerProps) => (
    <div className={styles.root} role="dialog" aria-label={labels.title}>
        <span className={styles.emoji} aria-hidden="true">
            🍪
        </span>

        <div className={styles.body}>
            <h3 className={styles.title}>{labels.title}</h3>
            <p className={styles.description}>{labels.description}</p>
            {/* Static legal PDF, opens in a new tab — a plain anchor, not the router Link. */}
            <a className={styles.learnMore} href={learnMoreHref} target="_blank" rel="noreferrer">
                {labels.learnMore}
                <VisuallyHidden>{labels.aboutPolicy}</VisuallyHidden>
            </a>
        </div>

        <div className={styles.actions}>
            <Button variant="secondary" size="small" onClick={onDecline}>
                {labels.decline}
            </Button>
            <Button variant="primary" size="small" onClick={onAccept}>
                {labels.allow}
            </Button>
        </div>
    </div>
)
